import React from 'react';
import { Link } from 'react-router-dom';
import useReveal from '../hooks/useReveal';
import logo from '../assets/logo.png';
import SEO from '../components/SEO';

const VALUES = [
  { n:'01', title:'Ownership',           desc:'We treat your system like it\'s ours. That means flagging problems early, thinking long-term, and never disappearing when things get hard.' },
  { n:'02', title:'Simplicity',          desc:'The best solution is the simplest one that solves the real problem. We resist over-engineering and build systems your future team can understand.' },
  { n:'03', title:'Reliability',         desc:'We build things that work at 3am when no one is watching. Error handling, monitoring, and graceful failures are not optional extras.' },
  { n:'04', title:'Speed with Quality',  desc:'Fast and clean are not opposites. We use battle-tested patterns and clean architecture to move quickly without accumulating debt.' },
  { n:'05', title:'Clear Communication', desc:'No jargon, no ghosting, no surprises. You\'ll always know what we\'re building, why, and when it ships.' },
  { n:'06', title:'Real-World Focus',    desc:'We build for production, not demos. Every architectural decision is made with maintenance, scale, and future developers in mind.' },
];

const EXPERTISE = [
  { i:'⚙️', title:'Backend Systems',       desc:'Django, FastAPI, PostgreSQL, REST APIs — production-first from day one.' },
  { i:'🤖', title:'AI Integration',        desc:'OpenAI, Ollama, RAG pipelines — AI that actually replaces manual work.' },
  { i:'📄', title:'Document Processing',   desc:'OCR + NLP pipelines for invoices, contracts, and enterprise documents.' },
  { i:'☁️', title:'Cloud Engineering',     desc:'AWS deployments, Docker, CI/CD, monitoring — full production infra.' },
  { i:'⚡', title:'Solar Engineering',     desc:'Simulation backends, shade analysis, 100MW+ project infrastructure.' },
  { i:'📊', title:'Data Engineering',      desc:'Airflow DAGs, ETL pipelines, MLflow, and analytics backends.' },
];

export default function About() {
  useReveal();
  return (
    <div className="page">
      <SEO
        title="About Arhatinfo — Rohit Jain, Backend Engineer & AI Specialist"
        description="Arhatinfo is a backend engineering and AI automation agency founded by Rohit Jain. We build scalable Python systems, AI-powered workflows, and cloud infrastructure for businesses worldwide."
        keywords="about arhatinfo, Rohit Jain, backend engineer, AI automation specialist, Python developer, Django expert, software agency, cloud engineer, OpenAI developer"
        canonical="https://arhatinfo.com/about"
        og={{
          title:       "About Arhatinfo — Rohit Jain, Backend Engineer & AI Specialist",
          description: "Backend engineering and AI automation agency. Python · Django · FastAPI · OpenAI · AWS. Built for businesses that need reliable, scalable software.",
          url:         "https://arhatinfo.com/about",
          image:       "https://arhatinfo.com/og-about.png",
        }}
      />
    <section className="section" style={{ paddingTop: 0 }}>
        <div className="wrap">

      <div className="ph rv">
        <div className="s-label">About Us</div>
        <h1>Engineering With<br />Ownership &amp; Precision</h1>
        <p className="lead">We are a software engineering company focused on building scalable backend systems, AI-powered automation, and cloud-native applications that work in production — not just in demos.</p>
      </div>


          {/* Founder + Expertise */}
          <div className="about-grid">
            <div className="rv">
              {/* <div className="founder-card">
                <div className="founder-avatar">
                  <img src={logo} alt="arhatinfo" />
                </div>
                <h3>Rohit Jain</h3>
                <div className="founder-role">
                  Backend Engineer · AI Automation Specialist<br />
                  Solar Optimization Engineer · Founder, arhatinfo.com
                </div>
                <p>5+ years building production-grade backend systems, REST APIs, AI-powered workflows, and simulation platforms across industries ranging from SaaS to large-scale solar energy.</p>
                <p>Started arhatinfo.com to bring engineering discipline and production thinking to clients who need more than just working code — they need systems built to last.</p>
                <div className="founder-links">
                  <a href="https://github.com" target="_blank" rel="noreferrer" className="flink">GitHub</a>
                  <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="flink">LinkedIn</a>
                  <a href="https://medium.com" target="_blank" rel="noreferrer" className="flink">Medium</a>
                  <Link to="/contact" className="flink">Contact</Link>
                </div>
              </div> */}
            </div>

            <div className="rv d1">
              <div className="s-label" style={{ marginBottom: '1.4rem' }}>Areas of Expertise</div>
              <h2 className="s-title" style={{ marginBottom: '1.5rem' }}>What Arhat Info Builds</h2>
              <div className="exp-grid">
                {EXPERTISE.map((e, i) => (
                  <div key={i} className="exp-item">
                    <div className="exp-ico">{e.i}</div>
                    <h4>{e.title}</h4>
                    <p>{e.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Values */}
          <div className="rv" style={{ marginBottom: '1.5rem' }}>
            <div className="s-label" style={{ marginBottom: '1.2rem' }}>Our Values</div>
            <h2 className="s-title" style={{ marginBottom: '2rem' }}>How We Work</h2>
          </div>
          <div className="val-grid">
            {VALUES.map((v, i) => (
              <div key={i} className={`val-card rv d${(i % 3) + 1}`}>
                <div className="val-num">{v.n}</div>
                <h4>{v.title}</h4>
                <p>{v.desc}</p>
              </div>
            ))}
          </div>

          {/* Mission */}
          <div className="mission-box rv">
            <blockquote>
              "To help businesses build <em>reliable software systems that scale</em>,
              while leveraging AI to automate real workflows — not just to demo."
            </blockquote>
            <p className="qwho">— The arhatinfo.com mission</p>
            <div style={{ marginTop: '2rem' }}>
              <Link to="/contact" className="btn-p">Start a Project →</Link>
            </div>
          </div>

        </div>
      </section>
    </div>
  );
}
